import React, { FC } from 'react';

import { TutorialContainer } from 'components/Pages/Tutorial';

export const Tutorial: FC = () => {
  return <TutorialContainer />;
};
